"use client";

import { useRef, useEffect } from "react";
import { useAdContext } from "./AdContextProvider";
import { injectHTML } from "./injectHTML";

interface AdSlotProps {
    id: string;
    className?: string;
}

export function AdSlot({ id, className }: AdSlotProps) {
    const adContext = useAdContext();
    const containerRef = useRef<HTMLDivElement>(null);

    const code = adContext?.slots[id];

    useEffect(() => {
        if (!containerRef.current || !code) return;
        injectHTML(containerRef.current, code);
    }, [code]);

    if (!adContext || !code) return null;

    return (
        <div
            ref={containerRef}
            id={`ad-${id}`}
            data-ad-slot={id}
            data-page-type={adContext.pageType}
            data-tenant={adContext.tenant}
            className={className}
        />
    );
}
